<!-- <template>
    <div id="printPDF">
        
    </div>
</template> -->


<template>
    <div>
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            :filename="data.bast_no"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            ref="printQrReceipt"
        >
            <section slot="pdf-content">
                <div class=" w-100" style="padding:40px;color:black !important">
                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <div >
                            <!-- {{data}} -->
                            <img src="@/assets/img/logo/qtrust.png" style="width:150px;height: auto;"/>
                        </div>
                        <div >
                            <!-- {{data}} -->
                            <img src="/mpm-distributor.png" style="width:150px;height: auto;"/>
                        </div>
                    </div>

                    <!-- {{ data }} -->

                    <h3 style="color:black !important" class="mt-4">SURAT PENGANTAR</h3>

                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <div >
                            <!-- {{data}} -->
                            <h5>NO. {{ data.po_no }}</h5>
                        </div>
                        <div >
                            <!-- {{data}} -->
                            <h5>{{ data.bast_no }}</h5>
                        </div>
                    </div>

                    <hr style="color:black">

                    <div style="display: flex;justify-content: flex-end;">
                        <h5 class="mr-4 mt-4">Surabaya , {{ moment(data.received_at).format("DD MMMM Y") }}</h5>
                    </div>

                    <h5 class="mt-4">Kepada</h5>


                    <div class="ml-5 mt-4 mr-2" style="border-bottom: 1px solid black;">
                        <h5>{{ data.receiver_name }}</h5>
                    </div>

                    <h5 class="mt-4">Harap Diterima</h5>


                    <div class="ml-5 mt-4 mr-2">
                        <h5>{{ numberWithCommas(data.qty) }} QR</h5> 
                    </div>

                  

                    <div style="display: flex;justify-content: space-between; align-items: center;margin-top:40%;margin-left: 5%;margin-right: 5%;">
                        <div class="text-center">
                            <h5>Yang Menerima,</h5>
                            <img :src="data.receiver_signature" style="width:200px;height: auto;"/>

                            <div class="mt-3 " style="display: flex;justify-content: space-between; margin: 0 10px;">
                                <div>
                                    (
                                </div>
                                <div style="border-bottom: 1px dotted black; min-width: 150px;">
                                    <h5>{{ data.receiver_name }}</h5>
                                </div>
                                <div>
                                    )
                                </div>

                            </div>
                        </div>

                        <div class="text-center">
                            <h5>Hormat Kami,</h5>
                            <img :src="data.sender_signature" style="width:200px;height: auto;"/>

                            <div class="mt-3 " style="display: flex;justify-content: space-between; margin: 0 10px;">
                                <div>
                                    (
                                </div>
                                <div style="min-width: 150px;">
                                    <h5>{{ data.sender_name }}</h5>
                                </div>
                                <div>
                                    )
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                

                
            </section>
        </vue-html2pdf>
    </div>
 </template>

<script>

import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'

export default {
    props : ['data'],
    data () {
        return {
            moment
        }
    },
    methods: {
        /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
        generateReport () {
            this.$refs.printQrReceipt.generatePdf()
        }
    },

    components: {
        VueHtml2pdf
    }
}
</script>